import CardStatusTag from "../../components/CardStatusTag";
import { isCardExpired } from "../../utils/common-utils";

const imgPath = "/assets/icons";

export const prepareCards = (content) => {
  const cardsList = [];

  content.forEach((account) => {
    const { id, bank, expMonth, expYear, last4 } = account;

    const expire = isCardExpired(expMonth, expYear);

    cardsList.push({
      key: id,
      imgSrc: `${imgPath}/saved-card.svg`,
      title: (
        <CardStatusTag bankTitle={bank} expMonth={expMonth} expYear={expYear} />
      ),
      subTitle: `**** ** *** ${last4}`,
      cardNumber: "",
      disabled: expire,
      label: (
        <div className="bank-meta-content">
          <div>{bank}</div>
          <div>{`**** ** *** ${last4}`}</div>
        </div>
      ),
      value: id,
      icon: "/assets/icons/delete-withdrawal-account.svg",
    });
  });

  return cardsList;
};

export const setColSize1 = (resizeWidth) => {
  switch (true) {
    case resizeWidth < 376:
      return 5;
    case resizeWidth < 993:
      return 4;
    case resizeWidth < 1380:
      return 3;
    default:
      return 2;
  }
};

export const setColSize2 = (resizeWidth) => {
  switch (true) {
    case resizeWidth < 376:
      return 19;
    case resizeWidth < 993:
      return 20;
    case resizeWidth < 1380:
      return 21;
    default:
      return 22;
  }
};
